import { z } from 'zod';
import { User } from '../../helpers/User';

export const schema = z.object({
  email: z.string().email('Email is required'),
  password: z.string()
    .min(8, 'Password must be at least 8 characters')
    .regex(/[A-Z]/, 'Password must contain at least one uppercase letter')
    .regex(/[0-9]/, 'Password must contain at least one number')
    .regex(/[^a-zA-Z0-9]/, 'Password must contain at least one special character'),
  displayName: z.string().min(1, 'Name is required'),
});

export type InputType = z.infer<typeof schema>;

export type OutputType = {
  user: User;
};

export const postRegister = async (
  body: z.infer<typeof schema> & { turnstileToken?: string },
  init?: RequestInit,
): Promise<OutputType> => {
  const { turnstileToken, ...rest } = body as any;
  const validatedInput = schema.parse(rest);
  const result = await fetch(`/_api/auth/register_with_password`, {
    method: 'POST',
    body: JSON.stringify({ ...validatedInput, turnstileToken }),
    ...init,
    headers: {
      'Content-Type': 'application/json',
      ...(init?.headers ?? {}),
    },
    credentials: 'include', // Important for cookies to be sent and received
  });

  if (!result.ok) {
    const text = await result.text();
    let errorData: any = {};
    try {
      errorData = text ? JSON.parse(text) : {};
    } catch (e) {
      // ignore JSON parse error, errorData stays {}
    }
    throw new Error(errorData.message || 'Registration failed');
  }

  const text = await result.text();
  return text ? JSON.parse(text) : {};
};
